import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import Button from 'components/form/Button';
import { limit } from 'utils/constants';
import { getUserType, objectToFormData, paymentColor } from 'utils/helpers';
import { fetchOtherConferencePasses, handlePassRegenerate } from 'store/slices';
import SeachInput from 'components/form/SeachInput';

const OtherConferencePasses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { eventId } = params;
  const userType = getUserType();
  const [abstractData, setAbstractData] = useState([]);
  const [abstractEventName, setAbstractEventName] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);

  const [searchPayload, setSearchPayload] = useState({
    email_id: '',
    member_id: '',
    phone_number: '',
  });

  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
    event_id: eventId,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [globalSearchVal, setGlobalSearchVal] = useState('');
  const [timer, setTimer] = useState('');

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const { view: viewAccess, create: createAccess } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'Instant Ticket Generate'
    )?.sub_permission || {};

  const getOtherConferencePasses = async (obj) => {
    let forData = objectToFormData(obj);
    const response = await dispatch(fetchOtherConferencePasses(forData));
    setAbstractEventName(response?.data?.event_name || '');
    setAbstractData(response?.data?.committee_members || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getOtherConferencePasses(newData);
  };
  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getOtherConferencePasses(newData);
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearchVal(e.target.value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      let newData = { ...filterData, ...searchPayload };
      newData = { ...newData, global_filter: e.target.value, offset: 0 };
      setIsLoading(true);
      setFilterData(newData);
      getOtherConferencePasses(newData);
    }, 800);
    setTimer(time);
  };

  useEffect(() => {
    getOtherConferencePasses({ ...filterData, ...searchPayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleRegenerate = async (id) => {
    setBtnLoading((prev) => ({ ...prev, [id]: true }));
    const payload = {
      type: 'CommitteeMember',
      id: id,
    };
    const response = await dispatch(handlePassRegenerate(payload));
    if (response.status === 200) {
      navigate(
        `/${userType}/instant-ticket-generate/${eventId}/other-conference-passes/${id}/view`
      );
    }
    setBtnLoading((prev) => ({ ...prev, [id]: false }));
  };

  const header = [
    {
      isSearch: true,
      searchInputName: 'user_name',
      title: 'Name',
    },

    {
      isSearch: true,
      searchInputName: 'email_id',
      title: 'Email Id',
    },
    {
      isSearch: true,
      searchInputName: 'phone_number',
      title: 'Phone Number',
    },
    {
      isSearch: true,
      searchInputName: 'attendee_type',
      title: 'Attendee Type',
    },
    {
      isSearch: true,
      searchInputName: 'country',
      title: 'Country',
    },

    {
      isSearch: true,
      searchInputName: 'university',
      title: 'University',
    },

    {
      isSearch: true,
      searchInputName: 'attendance',
      title: 'Attendance',
    },

    {
      isSearch: false,
      // searchLable: "View/Edit/Delete",
      title: 'Action',
    },
  ];

  const rowData = [];
  abstractData?.forEach((elem, index) => {
    const {
      attendance,
      attendee_type,
      country,
      email_id,
      phone_number,
      university,
      user_name,
      id,
    } = elem;
    let obj = [
      {
        value: user_name,
      },

      {
        value: email_id,
      },
      {
        value: phone_number,
      },
      {
        value: attendee_type,
      },
      {
        value: country,
      },
      {
        value: university,
      },
      {
        value: (
          <div className={paymentColor(attendance)}>
            {attendance ? attendance : '-'}
          </div>
        ),
      },

      {
        value: (
          <>
            {viewAccess === '1' && (
              <Button
                btnStyle="primary-light-outline"
                className="h-35 text-14-500 w-100 cmb-10 cps-20 cpe-20"
                text="View"
                onClick={() =>
                  navigate(
                    `/${userType}/instant-ticket-generate/${eventId}/other-conference-passes/${id}/view`
                  )
                }
              />
            )}
            {createAccess === '1' && (
              <Button
                btnStyle="primary-outline1"
                className="h-35 text-14-500 w-100"
                text="Generate"
                onClick={() => handleRegenerate(id)}
                disabled={btnLoading[id]}
                btnLoading={btnLoading[id]}
              />
            )}
          </>
        ),
      },
    ];
    rowData.push({ data: obj });
  });

  return (
    <div>
      <Card className="cmt-20 cps-20 cpe-20 cpt-20">
        <div className="d-flex justify-content-between align-items-center cpb-20">
          <div className="title-text text-16-500-20">{abstractEventName}</div>
          <div className="d-flex">
            <SeachInput
              placeholder="Search here"
              id="global_filter"
              value={globalSearchVal}
              onChange={handleGlobalSearch}
            />
          </div>
        </div>

        <Table
          isLoading={isLoading}
          header={header}
          rowData={rowData}
          filterData={filterData}
          // searchPayload={searchPayload}
          searchInputChange={handelChangeSearch}
          changeOffset={handelChangePagination}
          maxHeight="60vh"
        />
      </Card>
    </div>
  );
};

export default OtherConferencePasses;
